import React from 'react'

export default function MarketCard(props) {
    return <span div className="market-card">
        
        <p>{props.market.name}</p>
    </span>;
  }